import * as yup from "yup";

export const notesSchema = yup.object().shape({
  notes: yup.string(),
});
